import findDayByDate from "../../resolve/find-day-by-date";

export default function matchCurrentDay(
  date, // May be `null` for current date.
  parentSeasonContentForSchoolLevel,
  store,
) {
  return findDayByDate(date, parentSeasonContentForSchoolLevel, store);
}
